import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import { connect } from 'react-redux';
import NotesListing from "../../../components/Notes/Listing";
import CustomFieldsTab from "../CustomFieldsTab";
import StudentRecords from "../StudentRecords";
import RequirementsPreview from "../Requirements/RequirementsPreview";
import ApplicationRequirementsWrapper from "../Requirements/ApplicationRequirementsWrapper";
import { applicationTabSelected } from "../../../store/selectors/application";
import { useParams, Redirect } from 'react-router-dom';
import { Box } from '@applyboard/crystal-ui';
import { getTemplateString } from "../../../components/NoteTemplates/NoteTemplatesModal";
var Content = function Content(_ref) {
  var _ref$selected_tab = _ref.selected_tab,
    selected_tab = _ref$selected_tab === void 0 ? 'requirements' : _ref$selected_tab,
    searchParameters = _ref.searchParameters,
    permissions = _ref.permissions,
    DocumentVerificationModal = _ref.DocumentVerificationModal,
    VerificationResults = _ref.VerificationResults,
    reloadAggregatedData = _ref.reloadAggregatedData,
    RemoveFileDialog = _ref.RemoveFileDialog,
    HybridRequirementDecisionReasons = _ref.HybridRequirementDecisionReasons,
    HybridRequirementDialogButton = _ref.HybridRequirementDialogButton,
    HybridRequirementPreviewMode = _ref.HybridRequirementPreviewMode,
    isRequirementEvaluationPending = _ref.isRequirementEvaluationPending,
    aggregatedDataRequirements = _ref.aggregatedDataRequirements,
    ApplicantRequirementList = _ref.ApplicantRequirementList,
    AdminRequirementList = _ref.AdminRequirementList,
    renderNotesList = _ref.renderNotesList,
    commissionTab = _ref.commissionTab;
  var hasPermission = function hasPermission(name) {
    return permissions ? permissions[name] : false;
  };
  var tab = selected_tab.toLowerCase();
  switch (tab) {
    case 'applicant requirements':
      return ApplicantRequirementList ? /*#__PURE__*/React.createElement(ApplicantRequirementList, {
        requirementClassifications: ['applicant_requirement']
      }) : /*#__PURE__*/React.createElement(LegacyRequirementsList, {
        tab: tab,
        DocumentVerificationModal: DocumentVerificationModal,
        reloadAggregatedData: reloadAggregatedData,
        RemoveFileDialog: RemoveFileDialog,
        HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
        HybridRequirementDialogButton: HybridRequirementDialogButton,
        isRequirementEvaluationPending: isRequirementEvaluationPending,
        aggregatedDataRequirements: aggregatedDataRequirements
      });
    case 'admin requirements':
    case 'actions':
      return AdminRequirementList ? /*#__PURE__*/React.createElement(AdminRequirementList, {
        requirementClassifications: ['action_requirement', 'school_requirement']
      }) : /*#__PURE__*/React.createElement(LegacyRequirementsList, {
        tab: "actions",
        DocumentVerificationModal: DocumentVerificationModal,
        reloadAggregatedData: reloadAggregatedData,
        RemoveFileDialog: RemoveFileDialog,
        HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
        HybridRequirementDialogButton: HybridRequirementDialogButton,
        isRequirementEvaluationPending: isRequirementEvaluationPending,
        aggregatedDataRequirements: aggregatedDataRequirements
      });
    case 'notes':
      return renderNotesList ? renderNotesList({
        getTemplateString: getTemplateString,
        noteType: 'customer'
      }) : /*#__PURE__*/React.createElement(NotesListing, {
        publicOnly: true,
        searchParameters: searchParameters
      });
    case 'admin comments':
      return renderNotesList ? renderNotesList({
        getTemplateString: getTemplateString,
        noteType: 'admin'
      }) : /*#__PURE__*/React.createElement(NotesListing, {
        privateOnly: true,
        searchParameters: searchParameters
      });
    case 'preview requirements':
      if (hasPermission('update_requirement_status')) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RequirementsPreview, {
          DocumentVerificationModal: DocumentVerificationModal,
          VerificationResults: VerificationResults,
          reloadAggregatedData: reloadAggregatedData,
          HybridRequirementPreviewMode: HybridRequirementPreviewMode
        }));
      }
      break;
    case 'application details':
      if (hasPermission('show_custom_field_student') || hasPermission('show_custom_field_application')) {
        return /*#__PURE__*/React.createElement(CustomFieldsTab, null);
      }
      break;
    case 'student records':
      return /*#__PURE__*/React.createElement(StudentRecords, null);
    case 'commission':
      return /*#__PURE__*/React.createElement(Box, {
        pt: 4
      }, commissionTab);
    default:
      break;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationRequirementsWrapper, null));
};
function LegacyRequirementsList(_ref2) {
  var tab = _ref2.tab,
    DocumentVerificationModal = _ref2.DocumentVerificationModal,
    reloadAggregatedData = _ref2.reloadAggregatedData,
    RemoveFileDialog = _ref2.RemoveFileDialog,
    HybridRequirementDecisionReasons = _ref2.HybridRequirementDecisionReasons,
    HybridRequirementDialogButton = _ref2.HybridRequirementDialogButton,
    isRequirementEvaluationPending = _ref2.isRequirementEvaluationPending,
    aggregatedDataRequirements = _ref2.aggregatedDataRequirements;
  var params = useParams();
  if (params.requirement_id) {
    var _aggregatedDataRequir;
    var legacyId = (_aggregatedDataRequir = aggregatedDataRequirements.find(function (req) {
      return req.newId === params.requirement_id;
    })) === null || _aggregatedDataRequir === void 0 ? void 0 : _aggregatedDataRequir.id;
    if (legacyId) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: "/applications/".concat(params.application_id, "?tab=").concat(tab, "#req-").concat(legacyId)
      });
    }
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/applications/".concat(params.application_id, "?tab=").concat(tab)
    });
  }
  if (window.location.pathname.includes('admin-requirements')) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/applications/".concat(params.application_id, "?tab=actions")
    });
  }
  return /*#__PURE__*/React.createElement(ApplicationRequirementsWrapper, {
    tab: tab,
    DocumentVerificationModal: DocumentVerificationModal,
    reloadAggregatedData: reloadAggregatedData,
    RemoveFileDialog: RemoveFileDialog,
    HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
    HybridRequirementDialogButton: HybridRequirementDialogButton,
    isRequirementEvaluationPending: isRequirementEvaluationPending,
    aggregatedDataRequirements: aggregatedDataRequirements
  });
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    selected_tab: applicationTabSelected(state)
  };
};
var ContentComponent = connect(mapStateToProps)(Content); // eslint-disable-line @typescript-eslint/no-explicit-any
export default ContentComponent;